const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_PARTICIPANTS_LIST",
  FETCH_LIST_REQUEST: "FETCH_PARTICIPANTS_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_PARTICIPANTS_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_PARTICIPANTS_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_PARTICIPANTS_LIST",
}

export default LIST_ACTION_TYPES
